import { render, staticRenderFns } from "./yumiFooter.vue?vue&type=template&id=eb223204&"
import script from "./yumiFooter.vue?vue&type=script&lang=js&"
export * from "./yumiFooter.vue?vue&type=script&lang=js&"
import style0 from "./yumiFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports